/**
 * SASADM-0165 — helpers shared by the Whitelabel tab (`TenantHostnames`) and its
 * domain panel (`WhitelabelDomainPanel`).
 */
import type { HostnameType, WhitelabelHostnameDto } from '@/api/types';

export function fmtDate(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

// SASADM-0145 — one row per (type, app). `TYPE_ORDER` is copied verbatim from
// TenantOverview.tsx (no shared module there) so the screens agree on ordering.
export const TYPE_ORDER: HostnameType[] = ['APP', 'LOGIN', 'AUTH', 'API', 'ASSET', 'BRAND'];

/**
 * Surface key of a white-label domain host: an APP host with an app keys on that app
 * (`APP:<appId>`, so it pairs with the app's SYSTEM row); an unassigned APP host keys on
 * its own id; every other type keys on its type.
 */
export function whitelabelHostKey(h: WhitelabelHostnameDto): string {
  if (h.hostnameType !== 'APP') return h.hostnameType;
  return h.appId != null ? `APP:${h.appId}` : `APP:wl:${h.id}`;
}

/** SASADM-0171 — on the white-label domain: the domain itself or any host under it. */
export function isOnDomain(hostname: string, domain: string | null): boolean {
  return domain != null && (hostname === domain || hostname.endsWith(`.${domain}`));
}
